import { gt, _, bb } from "$json";
/* ask-to-stop:
 *
 * Ask user if it's ok before stopping a model
 *
 * Copyright (C) 2011, 2014 by Berkeley Bridge
 */

(function ($, doc) {
  var translations = {
    "Close the program?": {
      nl: "Programma afsluiten?",
      fr: "Fermer le programme?",
      de: "Schließen des Programms?",
      ru: "Да ли вы хотите закрыть программу?"
    }
  };

  $(function () {
    gt.addTranslations(translations);
    $(doc).off("click", ".bb-stop");
    $(doc).on("click", ".bb-stop", function () {
      if (confirm(_("Close the program?"))) bb.exit();
    });
  });
})(jQuery, document);
